import VeeValidate from 'vee-validate';
import Vue from 'vue';
import i18n from './i18n';
import messagesJP from './messages/jp';

const config = {
  fieldsBagName: 'fields-validate',
}
Vue.use(VeeValidate, config);
const dictionary = {
  jp: messagesJP
};

VeeValidate.Validator.localize(dictionary);
VeeValidate.Validator.localize(i18n.locale);

export default {
 VeeValidate
}